<template>

<div class="container-fluid slider p-0">
    <div class="floatingHeader" v-if="floatingHeader">
      <img alt="FlixLatino" class="logo-head w30 m-1" :src="$parent.img('https://flxassets.flixlatinogo.com/2020/img/logo_flix_2020.png')">
      <a  v-on:click="$parent.suscribe()" class="btn btn-danger btn-flg glow bigbutton w70 m-1" role="button">{{$parent.lang.slider.button}}</a>
    </div>
    <div id="banner-section" class="homebanner" :style="resoBanner">
          <video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop" v-if="hasVideo" class="videoBanner" v-bind:class="{ mobile: showMobile }" :key="resoVid" :poster="$parent.img(resoImg)">
            <source  :src="resoVid" type="video/mp4">
          </video>
          <div class="container" >
              
              <div class="row">
        
                  <div class="col-md-6 col-sm-6 col-xs-9 text-center banner-text justify-content-center m-auto textcontent">

                      <img alt="FlixLatino" class="logo-head w32" v-if="!$parent.showHead && $parent.isMobile && $parent.showLogo " :src="$parent.img('https://flximg.flixlatinogo.com/loadingph.png')"  v-lazyload :data-src="$parent.png('https://flxassets.flixlatinogo.com/2018/images/logo3-flix.png')">
<!--                      <h2 v-if="$parent.showHead || $parent.showLogo" style="margin-bottom: 30px;margin-top: -40px;font-size: 1.2em;">Tu cultura, tus películas</h2>-->
                      <br v-else/>
                      <div v-html="$parent.lang.slider.caption">
                        
                      </div>


                      

                  </div>
                  
              </div>
              <div class="d-none d-sm-block posters-section">
                <div class="row posters justify-content-center bring-div-to-front" v-for="(list,ip) in posterList" v-bind:key="ip">
                  <div
                      v-for="(fm,i) in list"
                      v-bind:key="i"
                      class="col-lg-2 col-sm-3">
                    <a :href="'#'+fm.slug">
                      <img class="w-100 rounded mb-3 poster-item" :src="$parent.img(fm.poster)" v-lazyload :title="fm.title" :alt="fm.title" >
                    </a>
                  </div>
                </div>
              </div>
            <div class="d-block d-sm-none posters-section">
              <div class="row posters justify-content-center bring-div-to-front">
                <div
                    v-for="(fm,i) in $parent.lang.movies.free.movies"
                    v-bind:key="i"
                    class="col-6">
                  <a :href="'#'+fm.slug">
                    <img class="w-100 rounded mb-3 poster-item" :src="$parent.img(fm.thumb)" v-lazyload :title="fm.title" :alt="fm.title" >
                  </a>
                </div>
              </div>
            </div>

              <!-- /.row -->

              <div class="row" v-if="$parent.lang.slider.timeline">
               
                <img v-on:click="$parent.suscribe()" alt="timeline" key="z1" v-if="showMobile" class="img-fluid" :src="'/api/?l=svg/'+($parent.supportWebP ? 'webp' : 'png')+'&lang='+$parent.currentLang">
                <img v-on:click="$parent.suscribe()" alt="timeline" key="z2" v-else class="img-fluid" style="width: 90%;max-width: 800px;margin: auto;" :src="'/api/?l=svg/'+($parent.supportWebP ? 'webp' : 'png')+'&size=desktop&lang='+$parent.currentLang">

              </div>





          </div>
      </div>

      <div class="scrollicon" @click="scrollToNext()">
        <div class="arrow arrow-first"></div>
        <div class="arrow arrow-second"></div>
      </div>

</div>

</template>


<script>



export default {
  name: 'flixSlider',
  components: {  },
  data(){ return {
      floatingHeader: false
    }
  },
  created: function () {

    // this.caption = lang.slider.caption;
    // this.img = lang.slider.img;
    // this.lang = lang.es;
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.injectCss()
    this.scrollEvents()
    
  },
  destroyed() {
      window.removeEventListener('resize', this.handleResize);
  },
  updated: function(){
    // this.profiling();

  },
  computed:{
    posterList: function(){
      var size = 4; var arrayOfArrays = [];
      for (var i=0; i<this.$parent.lang.movies.free.movies.length; i+=size) {
        arrayOfArrays.push(this.$parent.lang.movies.free.movies.slice(i,i+size));
      }
      return arrayOfArrays;
    },
    showMobile: function(){
      return this.$parent.isMobile
    },
    hasVideo: function(){
      if(this.showMobile){
        return (this.$parent.lang.slider.img.mobile.video && this.$parent.lang.slider.img.mobile.video != '')
      }else{
        return (this.$parent.lang.slider.img.desktop.video && this.$parent.lang.slider.img.desktop.video != '')
      }
    },
    resoImg: function(){
      return (this.showMobile ?  this.$parent.lang.slider.img.mobile.img : this.$parent.lang.slider.img.desktop.img);
    },
    resoVid: function(){

          return (this.showMobile ?  this.$parent.lang.slider.img.mobile.video : this.$parent.lang.slider.img.desktop.video);
    },
    resoBanner: function(){
        if(!this.hasVideo){

          var banner = (this.showMobile ?  this.$parent.lang.slider.img.mobile.img : this.$parent.lang.slider.img.desktop.img);

          return "background: url('"+this.$parent.img(banner)+"')!important;background-size: cover !important;background-position: center !important;";
        }else{
          return "";
        }
    }

  },
  
  methods:{

    scrollToNext(){
      let target = document.getElementById('weekly-releases-section');
      target.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      })
    },
    scrollEvents: function(){
      if (this.showMobile) {
        window.addEventListener("scroll", event => {
          let fromTop = window.scrollY;
          // console.log("ref position",this.$refs.subscribeButton.getBoundingClientRect().y)
          if (this.$refs.subscribeButton.getBoundingClientRect().y < 0){
            this.floatingHeader = true
          }else{
            this.floatingHeader = false
          }
          // mainNavLinks.forEach(link => {
          //   let section = document.querySelector(link.hash);
          //
          //   if (
          //       section.offsetTop <= fromTop &&
          //       section.offsetTop + section.offsetHeight > fromTop
          //   ) {
          //     link.classList.add("current");
          //   } else {
          //     link.classList.remove("current");
          //   }
          // });
        });
      }

    },

  injectCss: function() {
    let element = document.getElementById("dynamicCss");
    if(typeof(element) != 'undefined' && element != null){
      // do nothing
    } else{
      let e = document.createElement("style");
      e.id = "dynamicCss";
      e.innerHTML = this.$parent.lang.slider.css;
      document.head.appendChild(e);
    }
  },
  handleResize:function() {
            // if(window.innerWidth > 600){
            if(document.documentElement.clientWidth > 600){
              
              this.showMobile = false;
            }else{
              this.showMobile = true;
            }
            
        }
    

  }
  
}
</script>

<style>
body{
  overflow-x: hidden;
}
  video.videoBanner{
    position: absolute;
    top: 30%;
    left: 50%;
    min-width: 100%;
    /*min-height: 100%;*/
    width: auto;
    height: auto;
    z-index: 0;
    -ms-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
  }
  video.videoBanner.mobile{
  position: absolute;
  top: 49%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: 0;
  -ms-transform: translateX(-50%) translateY(-50%);
  -moz-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  }





  video.videoBanner.mobile {
      width: 100%;
  }

  .bigbutton{
    width: 200px;
    padding: 5px;
  }
.floatingHeader {
  position: fixed;
  top: 0px;
  z-index: 999;
  width: 100%;
}

.w70 {
  width: 70vw !important;
}
.w30 {
  width: 20vw;
}

.bring-div-to-front{
  position:relative;
  z-index: 99;
}
.poster-item{
  transition: all ease-in-out .2s;
}
.poster-item:hover{
  transform: scale(1.1);
}
.posters-section{
  padding-bottom: 5em;
}

</style>